module.exports = __webpack_public_path__ + "static/img/2.9fd704f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/7/3/eng/2.png
// module id = ZtCF
// module chunks = 0